import { Sequential as SequentialScale } from '@antv/scale';
export const Sequential = (options) => {
    return new SequentialScale(options);
};
Sequential.props = {};
//# sourceMappingURL=sequential.js.map